<script>
import Modal from '@/components/atoms/Modal'
import Spinner from '@/components/atoms/Spinner'
import ImageWrapper from '@/components/atoms/ImageWrapper'

export default {
    name: 'ModalLeavingCanteenScope',
    components: { Spinner, ImageWrapper, Modal },
    data() {
        return {
            confirmFunction: () => {
                return new Promise((resolve, reject) => {
                    this.$refs.ModalLeavingCanteenScope.openModal()
                    this.$refs.leave.onclick = () => {
                        this.$refs.ModalLeavingCanteenScope.closeModal()
                        return resolve()
                    }
                    this.$refs.stay.onclick = () => {
                        this.$refs.ModalLeavingCanteenScope.closeModal()
                        return reject()
                    }
                })
            },
        }
    },
    mounted() {
        this.$store.dispatch('canteen/setLeavingConfirm', this.confirmFunction)
    },
}
</script>

<template lang="pug">
modal.modal-rate(ref="ModalLeavingCanteenScope" :closable="false")
    template(v-slot:header)
        .modal-header-text.text-ellipsis {{ $t('canteen.leaving_scope.title') }}
    template(v-slot:body)
        p(v-html="$t('canteen.leaving_scope.text')") 
    template(v-slot:footer)
        button#test.btn.btn-primary(ref="leave") {{$t('canteen.leaving_scope.confirm')}}
        button.btn.btn-secondary(ref="stay") {{$t('canteen.leaving_scope.cancel')}}
</template>
